import { itemSortOrders } from './';

const myBidsSortOrders = {
    /*eslint-disable */
    ...itemSortOrders,
    BID_RECENT_FIRST: 'BID_RECENT_FIRST',
    BID_OLDEST_FIRST: 'BID_OLDEST_FIRST',
    /*eslint-enable */
} as const;

export default myBidsSortOrders;
